import React, { useEffect, useState } from "react";
import { List, Pagination } from "antd";
import "./ListProductos.css";
import { getApiUrl } from "../../../src/api/config.js";

// 🔹 Componente para renderizar imagen O video
const MediaRenderer = ({ src, alt, style }) => {
  const isVideo = () => {
    if (!src) return false;
    const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv'];
    return videoExtensions.some(ext => src.toLowerCase().endsWith(ext));
  };

  if (isVideo()) {
    return (
      <video
        controls
        style={style}
        preload="metadata"
      >
        <source src={src} type="video/mp4" />
        Tu navegador no soporta el elemento de video.
      </video>
    );
  }

  return <img src={src} alt={alt} style={style} />;
};

// 🔹 Componente Definitivo e Inteligente para procesar subtítulos con o sin dos puntos (:)
const DescripcionConVinetas = ({ textoDesdeBD }) => {
  if (!textoDesdeBD) return null;

  // 1. Si no contiene ningún punto medio, se muestra como párrafo normal justificado
  if (!textoDesdeBD.includes('·')) {
    return (
      <p className="justificado" style={{ color: "#000000", margin: 0 }}>
        {textoDesdeBD}
      </p>
    );
  }

  // 2. PRE-PROCESAMIENTO: Detectamos líneas que son títulos en MAYÚSCULAS y les anteponemos un "·" temporal 
  // para que el split los reconozca y separe limpiamente del resto de elementos.
  const lineas = textoDesdeBD.split('\n');
  const textoEstructurado = lineas
    .map(linea => {
      const lineaLimpia = linea.trim();
      // Si la línea está en mayúsculas sostenidas (letras, espacios, paréntesis, guiones), tiene más de 4 letras y no tiene viñeta:
      if (
        lineaLimpia.length > 4 && 
        !lineaLimpia.startsWith('·') && 
        lineaLimpia === lineaLimpia.toUpperCase()
      ) {
        return `· TITULO_DETECTADO:${lineaLimpia}`;
      }
      return linea;
    })
    .join('\n');

  // 3. Rompemos todo el bloque procesado por el carácter "·"
  const fragmentos = textoEstructurado.split('·').map(f => f.trim()).filter(f => f.length > 0);
  
  const elementosRenderizados = [];
  let listaActual = [];

  fragmentos.forEach((fragmento, index) => {
    // El primer elemento original siempre es el título principal superior de la tarjeta
    if (index === 0 && !fragmento.startsWith("TITULO_DETECTADO:")) {
      elementosRenderizados.push(
        <span key={`tit-${index}`} className="producto-descripcion-titulo">
          {fragmento.replace(/:+$/, "")}:
        </span>
      );
      return;
    }

    // Comprobamos si el fragmento fue marcado previamente como un subtítulo de sección
    if (fragmento.startsWith("TITULO_DETECTADO:")) {
      // Extraemos el texto real del título
      let tituloLimpio = fragmento.replace("TITULO_DETECTADO:", "").trim();
      
      // Si veníamos acumulando viñetas de la sección anterior, cerramos esa lista antes de pintar el título
      if (listaActual.length > 0) {
        elementosRenderizados.push(
          <ul key={`lista-${index}`} className="producto-descripcion-lista">
            {listaActual}
          </ul>
        );
        listaActual = [];
      }

      // Normalizamos el final del título asegurándonos de que conserve únicamente un ":" al final
      tituloLimpio = tituloLimpio.replace(/[:\s\-]+$/, "");

      // Renderizamos el subtítulo de forma independiente e impecable sin cortes
      elementosRenderizados.push(
        <span key={`new-tit-${index}`} className="producto-descripcion-titulo" style={{ marginTop: '20px', display: 'block' }}>
          {tituloLimpio}:
        </span>
      );

    } else {
      // Si es un ítem normal, limpiamos saltos de línea internos no deseados y va directo a la lista activa
      const itemLimpio = fragmento.replace(/[\r\n]+/g, ' ').trim();
      if (itemLimpio) {
        listaActual.push(<li key={`li-${index}`}>{itemLimpio}</li>);
      }
    }
  });

  // Si al finalizar el bucle quedaron viñetas sueltas por pintar, añadimos la última lista
  if (listaActual.length > 0) {
    elementosRenderizados.push(
      <ul key="lista-final" className="producto-descripcion-lista">
        {listaActual}
      </ul>
    );
  }

  return (
    <div className="producto-descripcion-container">
      {elementosRenderizados}
    </div>
  );
};

const ListProductos = ({ empresaId }) => {
  const [productos, setProductos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 1;

  useEffect(() => {
    console.log("👉 empresaId recibido en ListProductos:", empresaId);
    const fetchProductos = async () => {
      try {
        if (!empresaId) {
          console.warn("⚠️ empresaId no recibido en ListProductos");
          return;
        }

        const response = await fetch(getApiUrl(`/productos/${empresaId}`));
        const data = await response.json();
        console.log("👉 Productos recibidos:", data);
        setProductos(data);
      } catch (error) {
        console.error("❌ Error cargando productos:", error);
      }
    };

    fetchProductos();
  }, [empresaId]);

  const paginatedData = productos.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <div className="equipo">
      <List
        itemLayout="vertical"
        size="large"
        dataSource={paginatedData}
        renderItem={(item) => (
          <List.Item
            key={item.numero_producto}
            extra={
              <div style={{ width: 272, position: "relative", marginTop: "20px" }}>
                <MediaRenderer
                  src={item.link_imagen_producto}
                  alt={item.titulo}
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    display: "block",
                    objectFit: "cover",
                    margin: "0 auto",
                    justifyContent: "center",
                  }}
                />
              </div>
            }
          >
            <ul>
              <li className="phase-title-li">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#000000" }} 
                >
                  {item.descripcion1 || "Descripción principal"}
                </a>
              </li>
            </ul>

            <List.Item.Meta
              title={<a href={item.link_producto}>{item.titulo}</a>}
              description={<DescripcionConVinetas textoDesdeBD={item.descripcion2} />}
            />
          </List.Item>
        )}
      />

      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={productos.length}
        onChange={setCurrentPage}
      />
    </div>
  );
};

export default ListProductos;


